import { useQuery } from '@tanstack/react-query';
import OrganizationService from '@services/Organization/organization.service';

export const useBrands = () => {
  return useQuery({
    queryKey: ['brands'],
    queryFn: ({ signal }) => OrganizationService.getBrands(signal),
    staleTime: 60 * 60 * 1000, 
    gcTime: 60 * 60 * 1000, 
  });
};